import axios from '../axios'

var OccupiedEventsProvider = function () {
  return {
    /*
        Example uniqueid: Section-WWE-TX
        Example componentid: ci-20211111111959785
        Example field: mA_AVG || mA_MAX || mA_MIN
        Example range: -5d
      */
    async GetOccupiedEventsAsync (uniqueid, componentid, field, range) {
      return axios.get('/influx/section/' + uniqueid + '/' + componentid + '/' + field + '/' + range)
    }
  }
}
export default new OccupiedEventsProvider()



// WEBPACK FOOTER //
// ./src/providers/OccupiedEventsProvider.js